import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 TASK: Clone the Training Repository`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Open your terminal`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Clone the GitHub Repository into your directory of choice`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`git clone https://github.com/niklaushirt/ibm-aiops-deployer.git

`}</code></pre>
      </li>
    </ol>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go to the deployer directory`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`cd ibm-aiops-deployer
`}</code></pre>
      </li>
    </ol>
    <br />
    <hr />
    <h2>{`🚀 TASK: Connect to your OpenShift Cluster`}</h2>
    <p>{`Login to your OpenShift Cluster from your Terminal by using the `}<inlineCode parentName="p">{`oc login`}</inlineCode>{` command from the OpenShift Web Console.`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`Open your Openshift Web Console`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select `}<inlineCode parentName="p">{`Copy Login Command`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/01_fzth_ocp_connect.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Copy the `}<inlineCode parentName="p">{`oc login ..`}</inlineCode>{` string`}</p>
            <img parentName="li" {...{
              "src": "./../images/02_fzth_ocp_connect.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Open your terminal`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Paste the `}<inlineCode parentName="p">{`oc login ..`}</inlineCode>{` command from above`}</p>
          </li>
        </ol>
        <p>{`Now you’re good to start with the installation.`}</p>
      </AccordionItem>
    </Accordion>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      